module.exports = __webpack_public_path__ + "img/orange_106.d2f2b6b3.png";